import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
const Login = resolve => require(['@/components/Login'], resolve);
const SignUp = resolve => require(['@/components/SignUp'], resolve);
const CheckPhone = resolve => require(['@/components/signUp/CheckPhone'], resolve);
const InputInfo = resolve => require(['@/components/signUp/InputInfo'], resolve);
const SignUpDone = resolve => require(['@/components/signUp/SignUpDone'], resolve);
const GoodsList = resolve => require(['@/components/GoodsList'], resolve);
const GoodsDetail = resolve => require(['@/components/GoodsDetail'], resolve);
const ShoppingCart = resolve => require(['@/components/ShoppingCart'], resolve);
const Order = resolve => require(['@/components/Order'], resolve);
const Pay = resolve => require(['@/components/Pay'], resolve);
const PayDone = resolve => require(['@/components/PayDone'], resolve);
const Freeback = resolve => require(['@/components/Freeback'], resolve);
const Home = resolve => require(['@/components/Home'], resolve);
const MyAddress = resolve => require(['@/components/home/MyAddress'], resolve);
const AddAddress = resolve => require(['@/components/home/AddAddress'], resolve);
const MyOrder = resolve => require(['@/components/home/MyOrder'], resolve);
const MyShoppingCart = resolve => require(['@/components/home/MyShoppingCart'], resolve);
const Merchant = resolve => require(['@/components/Merchant'], resolve);
const Help = resolve => require(['@/components/Help'], resolve);
const ShopStreet = resolve => require(['@/components/ShopStreet'], resolve);
const DealerIn = resolve => require(['@/components/DealerIn'], resolve);
const Apply = resolve => require(['@/components/Apply'], resolve);
const BaiHuoDian = resolve => require(['@/components/BaiHuoDian'], resolve);
const DianZi = resolve => require(['@/components/DianZi'], resolve);
const BanGong = resolve => require(['@/components/BanGong'], resolve);
const JiaYong = resolve => require(['@/components/JiaYong'], resolve);

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/', // 首页
      name: 'Index',
      component: Index
    },
    {
      path: '/Login', // 登录
      name: 'Login',
      component: Login
    },
    {
      path: '/SignUp', // 注册
      name: 'SignUp',
      component: SignUp,
      children: [
        {
          path: '/',
          name: 'index',
          component: CheckPhone
        },
        {
          path: 'checkPhone',
          name: 'CheckPhone',
          component: CheckPhone
        },
        {
          path: 'inputInfo',
          name: 'InputInfo',
          component: InputInfo
        },
        {
          path: 'signUpDone',
          name: 'SignUpDone',
          component: SignUpDone
        }
      ]
    },
    {
      path: '/goodsList', // 商品列表
      name: 'GoodsList',
      component: GoodsList
    },
    {
      path: '/goodsDetail', // 商品详情
      name: 'GoodsDetail',
      component: GoodsDetail
    },
    {
      path: '/shoppingCart', // 商品详情
      name: 'ShoppingCart',
      component: ShoppingCart
    },
    {
      path: '/order', // 订单页面
      name: 'Order',
      component: Order
    },
    {
      path: '/pay', // 支付页面
      name: 'Pay',
      component: Pay
    },
    {
      path: '/payDone', // 支付成功页面
      name: 'PayDone',
      component: PayDone
    },
    {
      path: '/freeback', // 反馈页面
      name: 'Freeback',
      component: Freeback
    },
    {
      path: '/home', // 主页
      name: 'Home',
      component: Home,
      children: [
        {
          path: '/',
          name: 'HomeIndex',
          component: MyOrder
        },
        {
          path: 'myAddress',
          name: 'MyAddress',
          component: MyAddress
        },
        {
          path: 'addAddress',
          name: 'AddAddress',
          component: AddAddress
        },
        {
          path: 'myOrder',
          name: 'MyOrder',
          component: MyOrder
        },
        {
          path: 'myShoppingCart',
          name: 'MyShoppingCart',
          component: MyShoppingCart
        }
      ]
    },
    {
      path: '/merchant',
      name: 'Merchant',
      component: Merchant
    },
    {
      path: '/shop-street',
      name: 'ShopStreet',
      meta: {
        label: '店铺汇'
      },
      component: ShopStreet
    },
    {
      path: '/dealer-in',
      name: 'DealerIn',
      meta: {
        label: '配送方式'
      },
      component: DealerIn
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      children: [
        {
          path: 'payment-methods',
          name: 'PaymentMethods',
          meta: {
            label: '支付方式'
          },
          component: () => import('@/components/help/PaymentMethods')
        },
        {
          path: 'invoice-request',
          name: 'InvoiceRequest',
          meta: {
            label: '发票申领'
          },
          component: () => import('@/components/help/InvoiceRequest')
        },
        {
          path: 'login-reg',
          name: 'LoginReg',
          meta: {
            label: '登录注册'
          },
          component: () => import('@/components/help/LoginReg')
        },
        {
          path: 'user-aggrement',
          name: 'UserAggrement',
          meta: {
            label: '用户协议'
          },
          component: () => import('@/components/help/UserAggrement')
        },
        {
          path: 'post-product',
          name: 'PostProduct',
          meta: {
            label: '发布商品'
          },
          component: () => import('@/components/help/PostProduct')
        },
        {
          path: 'notes-for-sellers',
          name: 'NotesForSellers',
          meta: {
            label: '卖家须知'
          },
          component: () => import('@/components/help/NotesForSellers')
        },
        {
          path: 'about',
          name: 'About',
          meta: {
            label: '关于我们'
          },
          component: () => import('@/components/help/About')
        },
        {
          path: 'contact',
          name: 'Contact',
          meta: {
            label: '联系我们'
          },
          component: () => import('@/components/help/Contact')
        },
        {
          path: 'return-exchange',
          name: 'ReturnExchange',
          meta: {
            label: '退/换货'
          },
          component: () => import('@/components/help/ReturnExchange')
        },
        {
          path: 'cancellation',
          name: 'Cancellation',
          meta: {
            label: '取消订单'
          },
          component: () => import('@/components/help/Cancellation')
        },
        {
          path: 'secure-transaction',
          name: 'SecureTransaction',
          meta: {
            label: '安全交易'
          },
          component: () => import('@/components/help/SecureTransaction')
        },
        {
          path: 'privacy-policy',
          name: 'PrivacyPolicy',
          meta: {
            label: '隐私政策'
          },
          component: () => import('@/components/help/PrivacyPolicy')
        },
        {
          path: 'delivery-method',
          name: 'DeliveryMethod',
          meta: {
            label: '配送方式'
          },
          component: () => import('@/components/help/DeliveryMethod')
        }
      ]
    },
    {
      path: '/apply',
      name: 'apply',
      component: Apply
    },
    {
      path: '/rybh',
      name: 'rybh',
      component: BaiHuoDian
    },
    {
      path: '/dzcp',
      name: 'dzcp',
      component: DianZi
    },
    {
      path: '/bgyp',
      name: 'bgyp',
      component: BanGong
    },
    {
      path: '/jydq',
      name: 'jydq',
      component: JiaYong
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js